import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { Card, CardContent } from '../../components/ui/Card';
import { Link } from 'react-router-dom';

export const ForConsultants = () => {
  return (
    <div className="py-24 space-y-32">
      <section className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-[10px] font-black uppercase tracking-widest border border-indigo-100">
              For Konsulenter
            </div>
            <h1 className="text-5xl md:text-6xl font-black text-slate-900 leading-none tracking-tighter uppercase">
              Skaler dine <br/> <span className="text-indigo-600">rådgivningstjenester</span>
            </h1>
            <p className="text-xl text-slate-500 leading-relaxed font-medium">
              Slutt å bruke tid på manuelle rapporter og databehandling. HMS-innsikt gir deg en komplett verktøykasse for å levere førsteklasses prosesser for dine kunder.
            </p>
            <div className="flex gap-4">
              <Link to="/booking"><Button variant="primary" size="lg">Bli Partner</Button></Link>
            </div>
          </div>
          <div className="bg-indigo-600 rounded-[64px] p-12 shadow-3xl text-white">
            <div className="space-y-8">
              <div className="flex gap-6 items-center border-b border-white/10 pb-8">
                <SafeIcon name="Briefcase" size={40} />
                <div>
                  <h4 className="text-xl font-bold">Client Management</h4>
                  <p className="text-indigo-100 text-sm">Sentral styring av hele din kundeportefølje.</p>
                </div>
              </div>
              <div className="flex gap-6 items-center border-b border-white/10 pb-8">
                <SafeIcon name="Settings" size={40} />
                <div>
                  <h4 className="text-xl font-bold">Project Setup</h4>
                  <p className="text-indigo-100 text-sm">Sett opp kartlegginger og workshops på minutter.</p>
                </div>
              </div>
              <div className="flex gap-6 items-center">
                <SafeIcon name="FileText" size={40} />
                <div>
                  <h4 className="text-xl font-bold">Auto-reporting</h4>
                  <p className="text-indigo-100 text-sm">Generer 20-siders AI-analyser med ett klikk.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20 space-y-4">
            <h2 className="text-4xl font-black text-slate-900 uppercase tracking-tighter">Ditt Operative Operativsystem</h2>
            <p className="text-slate-500 font-medium">Fokusert på verdi for kunden, ikke administrasjon.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { t: 'Workshop Tools', i: 'Users', d: 'Ferdige opplegg og digitale verktøy for fasilitering.' },
              { t: 'AI Diagnosis', i: 'Zap', d: 'La algoritmen finne de skjulte mønstrene for deg.' },
              { t: 'Branding', i: 'PenTool', d: 'Levere rapporter med din egen logo og profil.' },
              { t: 'Benchmark', i: 'Activity', d: 'Sammenlign kunden mot nasjonale data umiddelbart.' }
            ].map((f, i) => (
              <Card key={i} className="border-none shadow-lg text-center h-full">
                <CardContent className="p-10 space-y-4">
                  <div className="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center mx-auto">
                    <SafeIcon name={f.i} />
                  </div>
                  <h4 className="font-bold text-slate-900 uppercase tracking-tight text-sm">{f.t}</h4>
                  <p className="text-xs text-slate-500 leading-relaxed">{f.d}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};